import PropTypes from "prop-types";

const VARIANT = {
  primary: "rec-btn-primary",
  ghost: "rec-btn-ghost",
};

export default function Button({
  variant,
  size,
  className,
  type,
  children,
  onClick,
  disabled,
  title,
}) {
  const cls = [VARIANT[variant] || VARIANT.primary, size === "sm" ? "rec-btn-sm" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} className={cls} onClick={onClick} disabled={disabled} title={title}>
      {children}
    </button>
  );
}

Button.propTypes = {
  variant: PropTypes.oneOf(["primary", "ghost"]),
  size: PropTypes.oneOf(["md", "sm"]),
  className: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

Button.defaultProps = {
  variant: "primary",
  size: "md",
  className: "",
  type: "button",
  children: null,
  onClick: undefined,
  disabled: false,
  title: undefined,
};
